import { useEffect, useState } from "react";
import { useGetPatientLettersQuery } from "../../redux/service/patient_letters_service";
import { AppListing } from "../../components/appListing";
import MainPageDialog from "../../components/mainPageDialog";
import { IoMdEye } from "react-icons/io";
import moment from "moment";
import { Icon } from "../../utils/icons";

export const PatientLetters = (props) => {
  const [lettersList, setLettersList] = useState([]);
  const [previewData, setPreviewData] = useState(null);

  const cols = [
    { title: "Letter", key: "template_name" },
    { title: "Type", key: "template_type", colClass: "capitalize" },
    { title: "Created by", key: "created_by" },
    { title: "Created on", key: "created", getData: item => moment(item?.created).format('MM/DD/YYYY h:mm A') },
    {
      title: "Status",
      getData: (item) => (item.is_signed == 1 ? "Signed" : "Draft"),
    },
    {
      title: "View",
      key: "preview",
      colClass: "",
      getData: () => (
        <Icon type='eye' />
      ),
      onClick: (item) => setPreviewData(item),
    },
  ];

  const { data, refetch, isFetching } = useGetPatientLettersQuery({shared_to_patient_portal: 1});

  useEffect(() => {
    if (data?.data) {
      setLettersList(data?.data);
    }
  }, [data]);

    return (
        <>
            <div className="flex border-gray-300 bg-gray-200 px-3 py-3 sm:px-4 flex-wrap items-center justify-between sm:flex-nowrap">
                <div className="">
                    <h3 className="text-base font-semibold leading-6 text-gray-900">Letters/Orders</h3>
                </div>
                <div className=" flex-shrink-0">
                    <button
                        type="button"
                        onClick={refetch}
                        className="relative inline-flex items-center rounded-md bg-blue-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">
                        Reload
                    </button>
                </div>
            </div>
            <div className="flex-auto bg-white justify-start p-3 text-start">
                <AppListing listData={lettersList || []} cols={cols} loading={isFetching} />
            </div>

            {/* dialogs */}
            {previewData && <MainPageDialog
              title={previewData.template_name}
              modalSize="md"
              maxHeight={true}
              footerList={[{title: 'Close',type: 'close', action: () => setPreviewData(null)}]}
              onCancelHandler={() => setPreviewData(null)}
            >
                <div dangerouslySetInnerHTML={{ __html: previewData.template}}></div>
            </MainPageDialog>}
        </>
    )
}
